import { combineReducers } from "redux";

import country from "../features/admin/masters/country/Slice";
import state from "../features/admin/masters/state/Slice";
import city from "../features/admin/masters/city/Slice";
import pincode from "../features/admin/masters/pincode/Slice";

import avgmonthlybill from "../features/admin/masters/avgmonthlybill/Slice";
import consultationtype from "../features/admin/masters/consultationtype/Slice";

import trustedacrosscommunity from "../features/admin/masters/trustedacrosscommunity/Slice";

import common from "../features/admin/common/Slice";

const masters = combineReducers({
  country,
  state,
  city,
  pincode,
  avgmonthlybill,
  trustedacrosscommunity,
  consultationtype,
  common
});

export default masters;
